import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/TaxSmart.png";
import emotion from "../../Assets/Projects/foodgo.png";
import editor from "../../Assets/Projects/StudyNotion.PNG";
import chatify from "../../Assets/Projects/NodeBase.PNG";
import suicide from "../../Assets/Projects/agenticbot.jpg";
import bitsOfCode from "../../Assets/Projects/MeetAI.PNG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="NodeBase"
              description="A workflow automation platform to design and execute event-driven processes, built with Next.js, Inngest, and PostgreSQL. Supports real-time execution, custom node flows, and reliable background job processing."
              ghLink="https://github.com/IshankSharma2178/node4work"
              demoLink="https://nodebase.ishankdev.me"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="MeetAI"
              description="A real-time AI meeting platform enabling 1:1 calls with custom agents using OpenAI Realtime API and GetStream, with recording, transcription, AI-generated summaries, and contextual chat support."
              ghLink="https://github.com/IshankSharma2178/meet-ai"
              demoLink="https://meetai.ishankdev.me/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="StudyNotion"
              description="An EdTech web application inspired by Udemy, enabling instructors to create and manage courses while students can enroll, stream video content, and track progress."
              ghLink="https://github.com/IshankSharma2178/Study-Notion--EdTech-App"
              demoLink="https://studynotion.ishankdev.me/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Tax Smart"
              description="A gamified financial literacy platform (SIH 2024 – 8th rank) where users learn taxation through games, earn coins, access an AI tax assistant, and redeem rewards for expert mentorship."
              ghLink="https://github.com/IshankSharma2178/Tax-Smart"
              demoLink="https://tax-smart.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Agentic Bot"
              description="A multi-agent AI chatbot system built using Python and LangChain, where a supervisor dynamically routes queries to specialized agents, enabling intelligent responses, tool usage, and context-aware interactions."
              ghLink="https://github.com/IshankSharma2178/Agentic-Chatbot"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Food Go"
              description="A Flutter and Firebase-based mobile app inspired by Zomato, enabling users to browse restaurants, explore menus, and place orders with real-time data synchronization."
              ghLink="https://github.com/IshankSharma2178/InstaFood-MobileApp"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
